module.exports = __webpack_public_path__ + "img/pr-21.21e72f8b.png";